import { _ as _extends } from '../../../extends-30811c5e.js';
import { _ as _slicedToArray } from '../../../slicedToArray-682b2282.js';
import { _ as _objectWithoutProperties } from '../../../objectWithoutProperties-dd908bcc.js';
import classNames from 'classnames';
import React__default, { forwardRef, useRef, useState } from 'react';
import { m as mergeRefs } from '../../../react-merge-refs.esm-71f6c94c.js';
import { getPrefixCls } from '../../../utils/getPrefix.js';
import { IconCrossCircle } from '../../Icon/IconCrossCircle.js';
import { IconCheckCircle } from '../../Icon/IconCheckCircle.js';
import '../../../defineProperty-6f298737.js';

var _excluded = ["className", "label", "name", "id", "caption", "dataTestid", "invalid", "valid", "disabled"];
var prefixCls = getPrefixCls('textarea');
var Textarea = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
    label = _ref.label,
    name = _ref.name,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? name : _ref$id,
    caption = _ref.caption,
    _ref$dataTestid = _ref.dataTestid,
    dataTestid = _ref$dataTestid === void 0 ? 'textarea' : _ref$dataTestid,
    invalid = _ref.invalid,
    valid = _ref.valid,
    disabled = _ref.disabled,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var textareaRef = useRef(null);
  var combinedRefs = mergeRefs([textareaRef, ref]);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  return /*#__PURE__*/React__default.createElement("div", {
    "sl-test-data": dataTestid,
    className: classNames(prefixCls, className, {
      'has-icon': invalid || valid,
      'is-disabled': disabled,
      'is-invalid': invalid,
      'is-valid': valid,
      'is-focused': isFocused
    })
  }, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: id,
    className: "".concat(prefixCls, "_label")
  }, label), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(prefixCls, "_control")
  }, /*#__PURE__*/React__default.createElement("textarea", _extends({}, otherProps, {
    id: id,
    className: "".concat(prefixCls, "_textarea"),
    ref: combinedRefs,
    name: name,
    onBlur: function onBlur() {
      return setIsFocused(false);
    },
    onFocus: function onFocus() {
      return setIsFocused(true);
    }
  })), valid && /*#__PURE__*/React__default.createElement(IconCheckCircle, {
    className: "".concat(prefixCls, "_icon")
  }), invalid && /*#__PURE__*/React__default.createElement(IconCrossCircle, {
    className: "".concat(prefixCls, "_icon")
  })), caption && /*#__PURE__*/React__default.createElement("label", {
    htmlFor: id,
    className: "".concat(prefixCls, "_caption")
  }, caption));
});

export { Textarea };
